import { useAuthContext } from "@/context/authentication/auth-context";
import ProponenteDashboard from "./proponente-dashboard";
import ServiceProviderDashboard from "./service-provider-dashboard";

/**
 * Main Dashboard Router
 * Routes to appropriate dashboard based on user role:
 * - Role 4 (Investidor/Validator): Currently shows Proponente (can be customized later)
 * - Role 5 (Produtor/Proponente): Shows Proponente Dashboard
 * - Role 6 (Prestador de Serviço): Shows Service Provider Dashboard
 */
export default function Dashboard() {
  const { person, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
      </div>
    );
  }

  // Role-based dashboard routing
  const userRole = person?.user.id_role;

  switch (userRole) {
    case 6: // Prestador de Serviço
      return <ServiceProviderDashboard />;
    case 5: // Produtor/Proponente
    case 4: // Investidor/Validator (shows proponente dashboard for now)
    default:
      return <ProponenteDashboard />;
  }
}
